<template>
  <div class="flex flex-col gap-4 max-w-md">
    <div class="flex items-center gap-3">
      <label class="text-base font-medium text-gray-700">{{ $ctx.locale == 'en' ? setting.enName : setting.arName }}</label>
      <el-button type="primary" circle size="small" @click="addItem" class="!w-7 !h-7">
        <el-icon><Plus /></el-icon>
      </el-button>
    </div>

    <div class="flex flex-col gap-3">
      <div v-for="(tag, index) in val" :key="index" class="flex items-center gap-2">
        <el-input
          v-model="val[index]"
          @input="changed = true"
          class="flex-1"
        />
        <el-button
          type="danger"
          text
          @click="handleClose(index)"
          class="!text-red-500 hover:!text-red-600 !p-1"
        >
          <el-icon size="18"><Close /></el-icon>
        </el-button>
      </div>
    </div>

    <el-button v-if="changed" @click="update" class="self-start mt-2">
      {{ t('update') }}
    </el-button>
  </div>
</template>

<script setup lang="ts">
import {useI18n} from "vue-i18n";
import {onMounted, ref} from "vue";
import {useSettingsStore} from "@/stores/settingsStore";
import {Plus, Close} from "@element-plus/icons-vue";

const props = defineProps(['setting'])

const messages = {
  en: {
    newTag: 'New Tag'
  },
  ar: {
    newTag: 'وسم جديد'
  },
}
const {t} = useI18n({messages, useScope: 'global'})
const settingsStore = useSettingsStore();

const val = ref<string[]>([])
const changed = ref(false)

function addItem() {
  val.value.push('')
  changed.value = true
}

onMounted(() => {
  // Initialize with empty array if null/undefined, or parse if it's a JSON string
  if (props.setting.value) {
    if (typeof props.setting.value === 'string') {
      try {
        val.value = JSON.parse(props.setting.value);
      } catch {
        val.value = [];
      }
    } else if (Array.isArray(props.setting.value)) {
      val.value = [...props.setting.value];
    } else {
      val.value = [];
    }
  } else {
    val.value = [];
  }
})

function handleClose(index: number) {
  val.value.splice(index, 1)
  changed.value = true
}

async function update() {
  try {
    // Store as JSON serialized string
    const jsonString = JSON.stringify(val.value)
    await settingsStore.updateSetting(props.setting.key, props.setting.id, jsonString)
    changed.value = false;
  } catch (e) {
    console.log(e)
  }
}
</script>

